import type { Locale } from "./locales";

/** Private native previews and published Mandarin links need no English suffix. */
export function quizLinkLabel(label: string, locale: Locale, href: string) {
  if (locale !== "zh-Hans") return label;
  const base = label.replace(/（英文）$/u, "");
  if (href.startsWith("/zh/") || href === "/zh" || href.startsWith("/dev/")) return base;
  return `${base}（英文）`;
}
